import React, { createRef, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import * as style from './Hooks/style';
import { NavMenu } from './Homepage/NavMenu';
import { TopMenu } from './Homepage/TopMenu';
import { Sect1 } from './Homepage/Sect1';
import { Sect2 } from './Homepage/Sect2';
import { Sect3 } from './Homepage/Sect3';
import { Sect4 } from './Homepage/Sect4';
import { Sect5 } from './Homepage/Sect5';
import debounce from './Hooks/debounce';
import useOnScreen from './Hooks/useIntersect.js';

const Index = () => {
// Number of Sections
const 
numSection = 5,
frefLinks = useRef([...Array(numSection+1)].map(() => createRef())).current,
onScreen = useOnScreen(frefLinks);

// Wheel Scroll Event
const pageScroll = e => {
  const 
  topSpace = Math.ceil((document.documentElement && document.documentElement.scrollTop) ||
  window.pageYOffset ||
  window.scrollY),
  viewSpace = (document.documentElement && document.documentElement.clientHeight) ||
  window.innerHeight,
  current = parseInt(topSpace / viewSpace + 1, 10);
  e.preventDefault();
  if (e.deltaY <= 0) {
    if (current===1) { return } else {
      return scrollLink(current - 1);
    };
  } else if (e.deltaY >= 0) {
    if (current===numSection) { return } else {
      return scrollLink(current + 1);
    };
  }
};

//Navigation Event
const scrollLink = debounce(function(i) {
  let frefLink = frefLinks[i];
  return frefLink.current.scrollIntoView({
    block: "center",
    behavior: "smooth"
  });
}, 300);

useEffect(() => {
  document.addEventListener("wheel", pageScroll, { passive: false });
  return () => document.removeEventListener("wheel", pageScroll, { passive: false });
  // eslint-disable-next-line
}, []);

return (
  <>
    <style.globalStyle />
    <TopMenu
      scrollToLinkA={() => {
        scrollLink(1);
      }}
      active1={onScreen[1]}
      scrollToLinkB={() => {
        scrollLink(2);
      }}
      active2={onScreen[2]}
      scrollToLinkC={() => {
        scrollLink(3);
      }}
      active3={onScreen[3]}
      scrollToLinkD={() => {
        scrollLink(4);
      }}
      active4={onScreen[4]}
      scrollToLinkE={() => {
        scrollLink(5);
      }}
      active5={onScreen[5]}
    />
    <NavMenu
      active1={onScreen[1]}
      active2={onScreen[2]}
      active3={onScreen[3]}
      active4={onScreen[4]}
      active5={onScreen[5]}
    />

    <style.SectionBg />
    <Sect1 fref={frefLinks[1]} />
    <Sect2 fref={frefLinks[2]} active2={onScreen[2]} />
    <Sect3 fref={frefLinks[3]} active3={onScreen[3]} />
    <Sect4 fref={frefLinks[4]} active4={onScreen[4]} />
    <Sect5 fref={frefLinks[5]} active5={onScreen[5]} />
  </>
);
}

ReactDOM.render(<Index />, document.getElementById("root"));

